/**
* 模版
**/
<template>
  <div class="tags">
    <el-tag
      :key="tag.menuname"
      type="info"
      v-for="(tag,index) in tags"
      :disable-transitions="false"
      :effect="setTagColor(tag)"
      :closable="tag.menuname=='首页'?false:true"
      @click="changeMenu(tag)"
      @close="handleClose(tag,index)">
      {{tag.menuname}}
    </el-tag>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    computed: {
      ...mapState({
        tags: state => state.tabList,
        historyTags: state => state.historyTabList
      })
    },

    methods: {
      ...mapMutations({
        close: 'closeTab'
      }),
      setTagColor(tag) {
        return this.$route.path === tag.url ? 'dark' : 'light'
      },
      changeMenu(tag) {
        //在走一遍vuex中 selectMenu方法，将tag也是内容传递进去
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: tag.url})
        localStorage.setItem('path',tag.url)
      },
      handleClose(tag, index) {
        let length = this.historyTags.length
        if (this.historyTags.length==1) {
          this.close(tag)
          this.$router.push({path:'/dashboard/Dashboard'})
          localStorage.setItem('path','/dashboard/Dashboard')
        } else {
          this.close(tag)
          this.$bus.$emit("clearKeepAlive", tag);
          if (index === length) {
            this.$router.push({path: this.historyTags[index - 2].url})
            localStorage.setItem('path',this.historyTags[index - 2].url)
          } else {
            this.$router.push({path: this.historyTags[index-1].url})
            localStorage.setItem('path',this.historyTags[index-1].url)
          }
        }
        // if (tag.menuname!== this.$route.menuname) {
        //   return
        // }
        // 判断vuex中的tabsList下标，如果跟长度相等，跳转后最一个页面
        // if (index === length) {
        //   this.$router.push({path: this.tags[index - 1].url})
        //   localStorage.setItem('path',this.tags[index - 1].url)
        // } else {
        //   this.$router.push({path: this.tags[index].url})
        //   localStorage.setItem('path',this.tags[index].url)
        // }
      }
    }
  }
</script>
<style scoped>
  /deep/.tags .el-tag {
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  /deep/.tags .el-tag--dark.el-tag--info {
    background-color: #ECF5FF;
    border: 1px solid #D9ECFF;
    color: #409EFF;
  }
  /deep/.tags .el-tag--dark.el-tag--info .el-tag__close {
    color: #409EFF;
  }
  /deep/.tags .el-tag--dark.el-tag--info .el-tag__close:hover {
    background: #ECF5FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/tags.vue